import Vue from "vue";
import VueI18n from "vue-i18n";
Vue.use(VueI18n);

const messages = {
  en: {
    message: {
      hello: "hello world",
      days: "days",
      hours: "hours",
      minutes: "minutes",
      seconds: "seconds",
      booking: "Get a ticket",
      more: "See more",
      news: "All our news",
      error: "Something went wrong, please try again",
      success: "Thank you for contacting us !",
      name: "Name",
      firstname: "Firstname",
      number: "Phone number",
      email: "Email address",
      message: "Your message",
      optin: "I want to receive updates and deals from City Aventure",
      submit: "Submit",
      agree: "I agree",
      refuse: "I refuse",
      "404": "Oops, the page you're looking for doesn't seem to exist!",
      "open-group": "Open upon booking for groups, associations, scools and businesses",
      "open-10-19": "Open from 10am to 7pm",
      "open-13-19": "Open from 1h30pm to 7pm",
      "open-14-18": "Open from 2pm to 6pm",
      closed: "Closed",
      party: "Party"
    },
    attractions: {
      zen: {
        text: "Zen",
        desc: "Zen entry : Access to the park and relaxation spaces"
      },
      delire: {
        text: "Delirious",
        desc:
          "Delirious entry : Access to games and attractions on the ground, no access to tree tracks"
      },
      evasion: {
        text: "Evasion",
        desc: "Evasion entry : full access to all the attractions and tree tracks"
      },
      ages: {
        "3-4ans": "3 to 4 years-old",
        "5-8ans": "5 to 8 years-old",
        "9+": "9+ years-old"
      },
      type: {
        "Au sol": "On the ground",
        "Dans les arbres": "Tree tracks"
      }
    },
    documentTitle: {
      checkout: "Buy tickets",
      "checkout-albigny": "Buy tickets",
      shop: "Buy tickets",
      "shop-success": "Purchase complete",
      "shop-error": "Purchase error",
      "shop-albigny": "Buy tickets",
      "shop-albigny-success": "Purchase complete",
      "shop-albigny-error": "Purchase error",
      contact: "Contact us",
      home: "Home page",
      teasing: "Teasing",
      restauration: "Food and drinks",
      parc: "The park",
      horaires: "When to come",
      conseils: "Tips",
      visite: "Preparing your day",
      anniversaires: "Birthdays",
      tarifs: "Entry fees",
      collectivités: "Collectivities and communities",
      scolaires: "Schools",
      ce: "Company benefits",
      "séminaires-perchés": "Business meetings",
      "mentions-legales": "Legal",
      "bons-plans": "Deals",
      "nos parcs": "Our parks",
      attractions: "Our attractions",
      "404-not-found": "Oops",
      blog: "Blog",
      "nous-trouver": "Finding Us",
      presse: "Press",
      "evg-evjf": "Bachelor Party",
      partenaires: "Partners",
      cahute: "Food and Drinks",
      canoe: "Canoe",
      "billetterie-sommaire": "Summary Ticketing",
      afterworks: "Afterworks",
      parclyonferme: "Parc Lyon Albigny temporarily closed",
      post: "Post",
      recrutement: "Recruitment",
      "reset-password": "Reset password",
      account: "My account",
      "cart-product": "Cart",
      "sign-in": "Sign in",
      "sign-up": "Sign up",
      "new-password": "New password",
      "cart-payment": "Payment",
      "cart-customer": "Customer"
    }
  },
  fr: {
    message: {
      hello: "bonjour tout le monde",
      days: "jours",
      hours: "heures",
      minutes: "minutes",
      seconds: "secondes",
      booking: "Billetterie",
      more: "Découvrir plus",
      news: "Toutes nos actus",
      error: "Erreur lors de l'envoi du formulaire, merci de réessayer",
      success: "Merci de votre inscription",
      name: "Nom",
      firstname: "Prénom",
      number: "Numéro de téléphone",
      email: "Adresse email",
      message: "Votre message",
      optin: "J'accepte de recevoir les actus et bons plans de City Aventure",
      submit: "Valider",
      agree: "J'accepte",
      refuse: "Je refuse",
      "404": "Désolé, la page que vous recherchez n'existe pas.",
      "open-group":
        "Parc ouvert sur réservation pour les groupes (écoles, entreprises et associations) ",
      "open-10-19": "Parc ouvert de 10h00 à 19h00",
      "open-1330-19": "Parc ouvert de 13h30 à 19h00",
      "open-13-19": "Parc ouvert de 13h30 à 19h00",
      "open-14-18": "Parc ouvert de 14h00 à 19h00",
      closed: "Parc fermé",
      party: (document.innerHTML =
        "Soirée Nocturne halloween : <a href='https://www.cityaventure.com/fr/blog/le-depeceur-d-albigny'>Lîle du dépeceur</a>")
    },
    attractions: {
      zen: {
        text: "Zen",
        desc: "Entrée Zen : Accès au parc et aux espaces détente"
      },
      delire: {
        text: "Délire",
        desc:
          "Entrée Délire : Accès aux jeux et aux attractions au sol, hors parcours dans les arbres"
      },
      evasion: {
        text: "Evasion",
        desc:
          "Entrée Evasion : Accès complet à toutes les attractions du parc et les parcours dans les arbres"
      },
      ages: {
        "3-4ans": "3 à 4 ans",
        "5-8ans": "5 à 8 ans",
        "9+": "9 ans et plus"
      },
      type: {
        "Au sol": "Jeux au sol",
        "Dans les arbres": "Parcours dans les arbres"
      }
    },
    documentTitle: {
      "shop-page": "Billetterie en ligne",
      shop: "Billetterie en ligne",
      "shop-success": "Achat terminé",
      "shop-error": "Erreur lors de l'achat",
      "shop-albigny": "Billetterie en ligne",
      "shop-albigny-success": "Achat terminé",
      "shop-albigny-error": "Erreur lors de l'achat",
      checkout: "Finaliser votre commande",
      "checkout-albigny": "Finaliser votre commande",
      contact: "Contact",
      home: "Page d'accueil",
      teasing: "Teasing fr",
      restauration: "Se restaurer",
      parc: "Le parc",
      horaires: "Horaires",
      conseils: "Conseils malins",
      visite: "Préparez votre visite",
      anniversaires: "Anniversaires",
      tarifs: "Tarifs",
      collectivités: "Collectivités",
      scolaires: "Ecoles",
      ce: "CE",
      "séminaires-perchés": "Séminaires perchés",
      "mentions-legales": "Mentions légales",
      "bons-plans": "Bons plans",
      "nos-parcs": "Nos parcs",
      attractions: "Nos attractions",
      "404-not-found": "Oups!",
      blog: "Nos actualités",
      "nous-trouver": "Nous Trouver",
      presse: "Presse",
      "evg-evjf": "Enterrement de vie de jeune fille / garçon",
      partenaires: "Partenaires",
      cahute: "La Cahute",
      canoe: "Canoe",
      "billetterie-sommaire": "Billeterie Sommaire",
      afterworks: "Afterworks",
      parclyonferme: "Parc Lyon Albigny temporairement fermé",
      recrutement: "Recrutement",
      post: "Article",
      "reset-password": "Réinitialiser votre mot de passe",

      "sign-in": "Se connecter",
      "sign-up": "Créer un compte",
      "new-password": "Nouveau mot de passe",
      "cart-payment": "Paiement",
      "cart-customer": "Mes informations",
      account: "Mon compte",
      "cart-product": "Mon panier",
      "cart-customer-albigny": "Mes informations",
      "account-albigny": "Mon compte",
      "cart-product-albigny": "Mon panier"
    }
  }
};

const i18n = new VueI18n({
  locale: "fr",
  messages
});

export default i18n;
